import { findPath } from '@libs/NwUtils';

export function getBookLinkedWebsites(book, websiteData) {
    const linkedSections = [];
    if (websiteData && websiteData.length && book.Divisions) {
        book.Divisions.forEach((item) => {
            linkedSections.push(findPath(websiteData, item.WebsiteCode, item.DivisionCode, ''));
        });
    }
    return linkedSections;
}
